var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrendingUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2722_3224",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 11
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    transform: "matrix(1 0 0 -1 0 10.5)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2722_3224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.06325 3.10398C6.9747 3.10398 6.90049 3.13394 6.84059 3.19385C6.7807 3.25378 6.75076 3.32803 6.75076 3.4166C6.75076 3.50519 6.7807 3.57939 6.84059 3.63922C6.90049 3.69904 6.9747 3.72896 7.06325 3.72896H7.98634L5.56325 6.12321L4.16122 4.72119C4.12581 4.68578 4.08512 4.659 4.03913 4.64083C3.99314 4.62267 3.94563 4.61359 3.89658 4.61359C3.84588 4.61359 3.79835 4.62267 3.75398 4.64083C3.70962 4.659 3.66928 4.68544 3.63295 4.72017L1.16661 7.20734C1.10892 7.26391 1.08008 7.33334 1.08008 7.41562C1.08008 7.49792 1.11269 7.57167 1.1779 7.63689C1.23769 7.69667 1.31058 7.72656 1.39658 7.72656C1.48258 7.72656 1.55576 7.69638 1.61612 7.63601L3.89658 5.35556L5.29962 6.7586C5.33862 6.7976 5.37993 6.82511 5.42356 6.84114C5.46718 6.85716 5.51392 6.86518 5.56378 6.86518C5.61363 6.86518 5.66019 6.85716 5.70346 6.84114C5.74673 6.82511 5.78787 6.7976 5.82686 6.7586L8.41742 4.16805V5.08314C8.41742 5.17168 8.44738 5.2459 8.5073 5.30579C8.56722 5.36568 8.64147 5.39563 8.73005 5.39563C8.81863 5.39563 8.89284 5.36568 8.95266 5.30579C9.01249 5.2459 9.0424 5.17168 9.0424 5.08314V3.48057C9.0424 3.37387 9.00631 3.28443 8.93413 3.21225C8.86195 3.14007 8.77251 3.10398 8.6658 3.10398H7.06325Z",
    fill: "#1DA260"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/trending_up.68e8f05890cc08c08879aab4c95dce94.svg";
export { ForwardRef as ReactComponent };